import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory"
import { CadastroBasico } from "./cadastro-basico"
import { CadastrosBasicoProvider } from "./context/cadastros-basico-context"
import { FORM_TYPES } from "./context/cadastros-basico-reducer"

export const CadastroBasicoFactory = ({formType}:{formType: FORM_TYPES}) => {
  const getTitle = (formType: FORM_TYPES): string => {
        switch (formType) {
            case FORM_TYPES.banners:
                return "Banners";
            case FORM_TYPES.linkServices:
                return "Link de Serviços";
            case FORM_TYPES.categoriesNews:
                return "Categoria de Noticias";
            case FORM_TYPES.news:
                return "Notícias";
                case FORM_TYPES.estruturaGovernametal:
                    return "Estrutura Governamental";
            default:
                return "";
        }
    }

    return (
        <BaseInternalFormFactory pageTitle={getTitle(formType)}>
            <CadastrosBasicoProvider>
                <CadastroBasico formType={formType} />
            </CadastrosBasicoProvider>
        </BaseInternalFormFactory>
    )
}